import { Box, Stack, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import { useTenant } from '../../../contexts/TenantContext';
import { tint } from '../../../utils/textStyles';

// „1 órával”, „30 perccel”, „1 óra 30 perccel”.
const formatMinutes = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (hours === 0) return `${rest} perccel`;
  if (rest === 0) return `${hours} órával`;
  return `${hours} óra ${rest} perccel`;
};

/**
 * The foot of the booking page's card: how close to its start a slot can still be booked
 * (DECISIONS.md D30) and a booking cancelled (D28), before the guest picks one (D31). It says
 * only the rules the tenant has, and nothing at all without either.
 */
const BookingTerms = () => {
  const { displayConfig, bookingDeadlineMinutes, cancellationDeadlineHours } = useTenant();
  const accent = displayConfig?.primaryColor;
  const textColor = displayConfig?.color;
  const quietColor = tint(textColor, 0.66);

  const rules = [];
  if (bookingDeadlineMinutes > 0) {
    rules.push({ icon: AccessTimeIcon, label: 'Foglalás', text: `legkésőbb ${formatMinutes(bookingDeadlineMinutes)} a kezdés előtt` });
  }
  if (cancellationDeadlineHours > 0) {
    rules.push({ icon: EventBusyIcon, label: 'Lemondás', text: `legkésőbb ${cancellationDeadlineHours} órával a kezdés előtt` });
  }
  if (rules.length === 0) return null;

  return (
    <Stack
      spacing={1}
      data-testid="booking-terms"
      sx={{
        px: { xs: 2, sm: 3 },
        pt: 1.75,
        pb: 2.25,
        backgroundColor: tint(accent, 0.06),
        borderTop: `1px solid ${tint(accent, 0.28)}`,
      }}
    >
      <Typography fontSize={11.5} letterSpacing="0.08em" textTransform="uppercase" sx={{ color: quietColor }}>
        Tudnivalók
      </Typography>
      {/* The rule's name next to its icon, and what it says under the name, so the two read as
          one item. */}
      {rules.map(({ icon: Icon, label, text }) => (
        <Box key={label} display="grid" gridTemplateColumns="auto 1fr" columnGap={1} alignItems="center">
          <Icon sx={{ fontSize: 18, color: accent }} />
          <Typography fontSize={13} fontWeight={600} sx={{ color: textColor }}>{label}</Typography>
          <Typography fontSize={13} sx={{ gridColumn: 2, color: quietColor }}>{text}</Typography>
        </Box>
      ))}
    </Stack>
  );
};

export default BookingTerms;
